module.exports = __webpack_public_path__ + "static/img/6-4.d87e880.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/6-4.png
// module id = i0vv
// module chunks = 1